(() => {
  class CloneProductController {
    constructor($scope, toastr, ProductsService, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        toastr,
        ProductsService,
        ngDialog,
        editing: false,
        productCode: "",
        productSKU: ""
      });
    }

    close() {
      this.$scope.closeThisDialog();
    }

    submit() {
      this.$scope.closeThisDialog({
        "code": this.productCode,
        "SKU": this.productSKU
      });
    }

  }

  CloneProductController.$inject = ["$scope", "toastr", "ProductsService", "ngDialog"];
  angular.module('pims').controller('CloneProductController', CloneProductController);
})();